"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Content = _ref => {
  let {
    className,
    text,
    children,
    renderAs,
    size,
    // eslint-disable-next-line no-unused-vars
    allowedTags,
    // eslint-disable-next-line no-unused-vars
    allowedAttributes,
    useProfiles,
    namespace,
    addTags,
    forbidTags,
    forbidAttributes,
    addAttributes,
    allowAriaAttributes,
    allowDataAttribute,
    addDataUriTags,
    addUriSafeAttributes,
    noWrapper
  } = _ref;
  const classNames = (0, _classnames.default)({
    [`is-${size}`]: size,
    content: !noWrapper
  });
  const RenderAs = renderAs;
  const purifyProps = {};
  if (typeof allowedTags !== 'undefined') {
    purifyProps.ALLOWED_TAGS = allowedTags;
  }
  if (typeof allowedAttributes !== 'undefined') {
    purifyProps.ALLOWED_ATTR = allowedAttributes;
  }
  if (typeof useProfiles !== 'undefined') {
    purifyProps.USE_PROFILES = useProfiles;
  }
  if (typeof namespace !== 'undefined') {
    purifyProps.NAMESPACE = namespace;
  }
  if (typeof forbidTags !== 'undefined') {
    purifyProps.FORBID_TAGS = forbidTags;
  }
  if (typeof forbidAttributes !== 'undefined') {
    purifyProps.FORBID_ATTR = forbidAttributes;
  }
  if (typeof addTags !== 'undefined') {
    purifyProps.ADD_TAGS = addTags;
  }
  if (typeof addAttributes !== 'undefined') {
    purifyProps.ADD_ATTR = addAttributes;
  }
  if (typeof allowAriaAttributes !== 'undefined') {
    purifyProps.ALLOW_ARIA_ATTR = allowAriaAttributes;
  }
  if (typeof allowDataAttribute !== 'undefined') {
    purifyProps.ALLOW_DATA_ATTR = allowDataAttribute;
  }
  if (typeof addDataUriTags !== 'undefined') {
    purifyProps.ADD_DATA_URI_TAGS = addDataUriTags;
  }
  if (typeof addUriSafeAttributes !== 'undefined') {
    purifyProps.ADD_URI_SAFE_ATTR = addUriSafeAttributes;
  }
  if (text) {
    return /*#__PURE__*/_react.default.createElement(RenderAs, {
      className: (0, _classnames.default)(className, classNames) || undefined,
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(text, purifyProps)
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)(className, classNames) || undefined
  }, children);
};
Content.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  className: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['normal', 'small', 'medium', 'large']), _propTypes.default.string]),
  noWrapper: _propTypes.default.bool,
  text: _propTypes.default.string,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
  allowedTags: _propTypes.default.arrayOf(_propTypes.default.string),
  allowedAttributes: _propTypes.default.arrayOf(_propTypes.default.string),
  useProfiles: _propTypes.default.shape({
    html: _propTypes.default.bool,
    svg: _propTypes.default.bool,
    svgFilters: _propTypes.default.bool,
    mathMl: _propTypes.default.bool
  }),
  namespace: _propTypes.default.string,
  addTags: _propTypes.default.arrayOf(_propTypes.default.string),
  forbidTags: _propTypes.default.arrayOf(_propTypes.default.string),
  forbidAttributes: _propTypes.default.arrayOf(_propTypes.default.string),
  addAttributes: _propTypes.default.arrayOf(_propTypes.default.string),
  allowAriaAttributes: _propTypes.default.bool,
  allowDataAttribute: _propTypes.default.bool,
  addDataUriTags: _propTypes.default.arrayOf(_propTypes.default.string),
  addUriSafeAttributes: _propTypes.default.arrayOf(_propTypes.default.string)
};
Content.defaultProps = {
  renderAs: 'div',
  noWrapper: false
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Content);
//# sourceMappingURL=Content.js.map